import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const AdminDashboard = () => {
  const navigate = useNavigate();

  const [feedbackData, setFeedbackData] = useState([]);
  const [totalResponses, setTotalResponses] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const token = localStorage.getItem("access");

  const loadFeedbackList = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API_BASE}/api/feedback-list`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await res.json();

      if (!res.ok) {
        setError(json.message || "Failed to load feedback.");
        return;
      }

      setFeedbackData(json.results || []);
      setTotalResponses(json.total_responses || 0);
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFeedbackList();
  }, []);

  const logout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("admin_logged_in");
    navigate("/admin-login");
  };

  return (
    <div style={{ padding: 40 }}>
      <h2>Admin Dashboard</h2>

      <button
        onClick={logout}
        style={{
          padding: "8px 18px",
          marginBottom: 20,
          borderRadius: 8,
          background: "#b91c1c",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        Logout
      </button>

      <h3>Total Responses: {totalResponses}</h3>

      {error && (
        <div style={{ color: "red", marginBottom: 20, fontWeight: 600 }}>
          {error}
        </div>
      )}

      {loading ? (
        <div>Loading feedback...</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: 20,
            }}
          >
            <thead>
              <tr style={{ background: "#f3f4f6" }}>
                <th style={thStyle}>Questions</th>
                <th style={thStyle}>1</th>
                <th style={thStyle}>2</th>
                <th style={thStyle}>3</th>
                <th style={thStyle}>4</th>
                <th style={thStyle}>5</th>
              </tr>
            </thead>

            <tbody>
              {feedbackData.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
                    No feedback found.
                  </td>
                </tr>
              ) : (
                feedbackData.map((item, index) => (
                  <tr key={index}>
                    <td dir="rtl" style={tdStyle}>{item.question}</td>

                    {item.options.map((opt, i) => (
                      <td key={i} style={tdStyle}>{opt.count}</td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const thStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
  fontWeight: 700,
  color: "#000"
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
};

export default AdminDashboard;
